import { useState, useEffect } from 'react';
var URLHashStore = /** @class */ (function () {
    function URLHashStore() {
    }
    URLHashStore.update = function () {
        if (window.location.href === URLHashStore.lastHREF)
            return;
        URLHashStore.lastHREF = window.location.href;
        URLHashStore.updatesCounter++;
        URLHashStore.map = new URLSearchParams(window.location.hash.split('#', 2).pop() || '');
        URLHashStore.listeners.forEach(function (f) { return f(URLHashStore.updatesCounter); });
    };
    URLHashStore.getHashValue = function (k) {
        var _a;
        URLHashStore.update();
        return ((_a = URLHashStore.map) === null || _a === void 0 ? void 0 : _a.get(k)) || undefined;
    };
    URLHashStore.setHashValue = function (k, v) {
        var _a, _b, _c;
        URLHashStore.update();
        var current = URLHashStore.getHashValue(k);
        if (current === v)
            return v;
        if (v) {
            (_a = URLHashStore.map) === null || _a === void 0 ? void 0 : _a.set(k, v);
        }
        else {
            (_b = URLHashStore.map) === null || _b === void 0 ? void 0 : _b.delete(k);
        }
        window.location.hash = ((_c = URLHashStore.map) === null || _c === void 0 ? void 0 : _c.toString()) || '';
        return v;
    };
    URLHashStore.addListener = function (listener) {
        this.listeners.add(listener);
    };
    URLHashStore.removeListener = function (listener) {
        this.listeners.delete(listener);
    };
    URLHashStore.listeners = new Set();
    URLHashStore.updatesCounter = 0;
    URLHashStore.lastHREF = '';
    return URLHashStore;
}());
URLHashStore.update();
window.addEventListener('hashchange', URLHashStore.update);
export default function useURLHashParams() {
    var _a = useState(0), setCounter = _a[1];
    useEffect(function () {
        URLHashStore.addListener(setCounter);
        return function () { return URLHashStore.removeListener(setCounter); };
    });
    return {
        getHashValue: URLHashStore.getHashValue,
        setHashValue: URLHashStore.setHashValue,
    };
}
//# sourceMappingURL=hashParameters.js.map